//Import required libraries
import React, { useState }  from 'react';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import exifr from 'exifr'

//Import custom components
import UploadForm from '../uploadForm/UploadForm';

//Import Styles
import './AddImage.scss';

//Import Data
import exifOptionsList from '../../../../assets/data/exifOptionsList.json'

//Import Utils
import { setImgDimensions } from '../../../../utils/utils'

const AddImage = props => {

    const [file, setFile] = useState(null);
    const [error, setError] = useState(null);
    const [fileMetaData, setFileMetaData] = useState(null);

    const types = ['image/png', 'image/jpeg'];

    const addImage = (e) => {
        let selected = e.target.files[0];
        // console.log(selected)

        if (selected && types.includes(selected.type)) {
        // console.log('File selected...')
        setFile(selected);
        setError('');
        
        //Update fileMetaData
        exifr.parse(selected, exifOptionsList).then(result => {
            setImgDimensions(selected, result, setFileMetaData)
        })
        } else {
        setFile(null);
        setError('Please select an image file (png or jpg)');
        setFileMetaData(null)
        }
    };

    return (
        <div className='add-image-button'>
            <label>
                <input type="file" onChange={addImage} className='hidden' />
                <AddCircleIcon className='add-icon' titleAccess='Upload image'/>
            </label>
            <span className='add-image-text'>Upload Image</span>
            {
                file && fileMetaData && <UploadForm file={file} 
                                                    setFile={setFile} 
                                                    fileMetaData={fileMetaData}
                                                    setFileMetaData={setFileMetaData}/>
            }
        </div>
    )
}

export default AddImage